import { Image } from "../../Cloud.model"
import { CurrentProfile, MinMax, Pipes, PipesDisabledConfigType, ServerCatalog, getComputePipeDisabled, getMinImage, getMinIndexMemoryImage, getPipeDisabled } from "../../Templates/Contract"
import { PipesDisabledConfig } from "../../Templates/Contract/utils/config/Contract.config"
import { UHCSliderProps } from "./AdvancedSettings"

export function getElementsSliderConfig(
    pipesConverted: Pipes,
    hardwareSelectedIndex: CurrentProfile,
    serverCatalogResponse: ServerCatalog,
    currentImage: Image): UHCSliderProps[] {
    
    const [compute, setCompute] = hardwareSelectedIndex.compute
    const [bandwidth, setBandwidth] = hardwareSelectedIndex.bandwidth
    const [disk, setDisk] = hardwareSelectedIndex.disk

    
    const bandwidthMinMax = getPipeDisabled(PipesDisabledConfig.band, hardwareSelectedIndex, serverCatalogResponse, currentImage)
    const diskMinMax = getPipeDisabled(PipesDisabledConfig.disk, hardwareSelectedIndex, serverCatalogResponse, currentImage)
    const memoryMinMax = getComputePipeDisabled(serverCatalogResponse, currentImage, diskMinMax)

    const handleComputeChange = (result: number) => {
        // euolAnalytics('[LP2] - configurar seu cloud', 'Memoria e processamento', 'Slider de Configurações Avançadas') //TODO: Avaliar o uso do UOLAnalytics
        setCompute(result)
    }

    const handleBandaChange = (result: number) => {
        // uolAnalytics('[LP2] - configurar seu cloud', 'Banda', 'Slider de Configurações Avançadas') //TODO: Avaliar o uso do UOLAnalytics
        setBandwidth(result)
    }

    const handleDiskChange = (result: number) => {
        // uolAnalytics('[LP2] - configurar seu cloud', 'Disco', 'Slider de Configurações Avançadas') //TODO: Avaliar o uso do UOLAnalytics
        setDisk(result)
    }

    return [
        {
            pipes: pipesConverted.computes,
            pipesDisabled: memoryMinMax,
            pipeState: {
                pipeSelected: compute,
                setPipeSelected: handleComputeChange
            },
            price: getFormatPrice(pipesConverted.computes[compute].price)
        },
        {
            pipes: pipesConverted.bandwidths,
            pipesDisabled: bandwidthMinMax,
            pipeState: {
                pipeSelected: bandwidth,
                setPipeSelected: handleBandaChange
            },
            price: getFormatPrice(pipesConverted.bandwidths[bandwidth].price)
        },
        {
            pipes: pipesConverted.disks,
            pipesDisabled: diskMinMax,
            pipeState: {
                pipeSelected: disk,
                setPipeSelected: handleDiskChange
            },
            price: getFormatPrice(pipesConverted.disks[disk].price)
        }
    ]
}


const getFormatPrice = (price: number) => {
    const formatterReal = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

    return price !== 0 ? formatterReal.format(price) : 'Incluso'
}

